export const bytesToMegaBytes = bytes => {
  if (typeof bytes !== 'number') return 0;
  return (bytes / (1024 * 1024)).toFixed(2);
};

export default bytesToMegaBytes;
